import { Button } from "@components/Buttons"
import CenteredTextBlock from "@components/ContentPage/CenteredTextBlock"
import Footer from "@components/Footer"
import { useIntl } from "@components/Intl"
import { Box, Container } from "@components/Layout"
import SEO from "@components/SEO"
import { Paragraph } from "@components/Typography"
import { ItemResponses } from "@kentico/kontent-delivery"
import { getLooks } from "@lib/kontent"
import { LooksPage } from "@lib/kontent/models-deprecated/looks_page"
import { LookDetailPage } from "@lib/kontent/models-deprecated/look_detail_page"
import React, { useState } from "react"
import LooksGrid from "./LooksGrid"

interface Props {
  content: LooksPage
  looks: ItemResponses.ListContentItemsResponse<LookDetailPage>
}

const Looks: React.FC<Props> = ({ content, looks }) => {
  const { messages, locale } = useIntl()
  const [loading, setLoading] = useState(false)
  const [items, setItems] = useState<LookDetailPage[]>(looks.items)
  const totalCount = looks?.pagination?.totalCount || 0

  const handleLoadMore = async () => {
    setLoading(true)
    const newPage = await getLooks({ lang: locale, skip: items.length }).catch(
      console.error
    )
    if (newPage) {
      setItems([...items, ...newPage.items])
    }
    setLoading(false)
  }

  return (
    <>
      <SEO
        title={content.seoMetaTitle.value}
        description={content.seoMetaDescription.value}
        imageUrl={content.seoMetaImage.value[0]?.url}
        urlKey="looks"
      />
      <Container pt={4}>
        <CenteredTextBlock titleAs="h1" title={content.title.value}>
          <Paragraph>{content.text.value}</Paragraph>
        </CenteredTextBlock>
        <LooksGrid items={items} />
        <Box display="flex" justifyContent="center" mb="5rem">
          {totalCount > items.length && (
            <Button
              variant="purple-border"
              state={loading ? "loading" : undefined}
              maxWidth={280}
              onClick={handleLoadMore}
            >
              {messages.global.showMore}
            </Button>
          )}
        </Box>
      </Container>

      <Footer />
    </>
  )
}

export default Looks
